// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__2EWhH","select":"Header_select__3lP8B","clinic":"Header_clinic__36ocm"};